import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { APPLIED_TO_SERVICE_CENTER_OPTIONS } from '../../../options';
import ApplicantIcon from '../../../../../img/formSectionIcons/applicant.svg';
import FormSection from '../../../../../components/FormComponents/FormSection';
import MainRadio from '../../../../../components/MUI/MainRadio';
import DateInputFieldWithValidation
from '../../../../../components/ValidationFormElements/DateInputFieldWithValidation';

import useStyles from '../../../../CompensationContainer/useStyles';

const ApplyToServiceCenter = ({
  formProps,
  accidentInfo,
  setValue,
}) => {
  const { errors, clearError } = formProps;
  const classes = useStyles();

  const [isAppliedToServiceCenter, setIsAppliedToServiceCenter] = useState(
    accidentInfo.isAppliedToServiceCenter || APPLIED_TO_SERVICE_CENTER_OPTIONS[0].value,
  );

  const [beforeSeeingDoctor, setBeforeSeeingDoctor] = useState(
    accidentInfo && accidentInfo.beforeSeeingDoctor,
  );
  const [afterSeeingDoctor, setAfterSeeingDoctor] = useState(
    accidentInfo && accidentInfo.afterSeeingDoctor,
  );
  const updateAfterSeeingDoctor = (newDate) => {
    setAfterSeeingDoctor(newDate);

    setValue('afterSeeingDoctor', newDate, true);
  };

  const updateBeforeSeeingDoctor = (newDate) => {
    setBeforeSeeingDoctor(newDate);

    setValue('beforeSeeingDoctor', newDate, true);
  };

  const handleIsAppliedToServiceCenter = (val) => {
    setIsAppliedToServiceCenter(val || null);
    setValue('isAppliedToServiceCenter', val || null, !!val);

    setBeforeSeeingDoctor(null);
    setValue('beforeSeeingDoctor', null);

    setAfterSeeingDoctor(null);
    setValue('afterSeeingDoctor', null);
  };

  return (
    <>
      <FormSection title="claim.accInfo.appliedToServiceCenter" icon={ApplicantIcon}>
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
          {APPLIED_TO_SERVICE_CENTER_OPTIONS.map(({ value, label }) => (
            <Grid item key={label}>
              <MainRadio
                labelKey={label}
                value={value || ''}
                checked={value === isAppliedToServiceCenter}
                onChange={({ e }) => handleIsAppliedToServiceCenter(e.target.value)}
              />
            </Grid>
          ))}
          {
            isAppliedToServiceCenter && (
            <>
              <Grid className={classes.divider} />
              {
                isAppliedToServiceCenter === APPLIED_TO_SERVICE_CENTER_OPTIONS[1].value && (
                <Grid item md={4} xs={12}>
                  <DateInputFieldWithValidation
                    formProps={{ errors, clearError }}
                    labelKey="claim.accInfo.appliedDate"
                    name="beforeSeeingDoctor"
                    value={beforeSeeingDoctor || null}
                    handleChange={(date) => {
                      // eslint-disable-next-line no-restricted-globals
                      if (date instanceof Date && !isNaN(date)) {
                        updateBeforeSeeingDoctor(date);
                      }
                    }}
                    maxDate={new Date()}
                    required
                  />
                </Grid>
                )
              }
              {
                 isAppliedToServiceCenter === APPLIED_TO_SERVICE_CENTER_OPTIONS[2].value && (
                 <Grid item md={4} xs={12}>
                   <DateInputFieldWithValidation
                     formProps={{ errors, clearError }}
                     labelKey="claim.accInfo.appliedDate"
                     name="afterSeeingDoctor"
                     value={afterSeeingDoctor || null}
                     handleChange={(date) => {
                       // eslint-disable-next-line no-restricted-globals
                       if (date instanceof Date && !isNaN(date)) {
                         updateAfterSeeingDoctor(date);
                       }
                     }}
                     maxDate={new Date()}
                     required
                   />
                 </Grid>
                 )
              }
            </>
            )
          }
        </Grid>
      </FormSection>
    </>
  );
};

ApplyToServiceCenter.propTypes = {
  accidentInfo: PropTypes.shape({
    beforeSeeingDoctor: PropTypes.instanceOf(Date),
    afterSeeingDoctor: PropTypes.instanceOf(Date),
    isAppliedToServiceCenter: PropTypes.string,
  }),
  formProps: PropTypes.shape({
    errors: PropTypes.shape({}),
    clearError: PropTypes.func,
  }),
  setValue: PropTypes.func,
  step: PropTypes.shape({}),
};

ApplyToServiceCenter.defaultProps = {
  accidentInfo: {
    beforeSeeingDoctor: undefined,
    afterSeeingDoctor: undefined,
    isAppliedToServiceCenter: undefined,
  },
  formProps: {},
  setValue: () => {},
  step: undefined,
};

export default ApplyToServiceCenter;
